/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 *
 *  Other things you may want to change:
 *   - Logo image:        src/assets/images/Flasher_logo.png  (replace the file)
 *   - Theme colors:      src/styles/GlobalStyles.ts  and  src/styles/theme.ts
 *   - Pricing plans:     src/components/home/Pricing.tsx  (the pricingPlans array)
 *   - Page content/copy: src/pages/*  and  src/components/home/*
 *   - Deploy domain:     add a public/CNAME file with your domain (GitHub Pages)
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    // Your product / company name. Shown in the header, footer, and page titles.
    name: 'Flash USDT Buy Online',
    tagline: 'Buy Flash USDT Online — Fast, Secure, Reliable',
    description:
      'Flash USDT Buy Online is the most reliable USDT flashing software. Flash up to $10,000,000 USDT daily with our secure, tradable, swappable, and transferable flash USDT solution.',
  },

  // Full production URL, no trailing slash. Used for canonical URLs and the sitemap.
  domain: 'https://flashusdtbuyonline.com',

  contact: {
    // Where the "Notify by Email" button on the payment page sends order emails.
    orderEmail: 'usdtflasherpro@gmail.com',
    // General support address.
    supportEmail: 'usdtflasherpro@gmail.com',
    // WhatsApp number in international format, DIGITS ONLY (no +, spaces or dashes).
    whatsapp: '447514003077',
    // Human-readable phone number for display.
    phoneDisplay: '+44 7514 003077',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  // Crypto wallet addresses shown (with QR codes) on the payment page.
  payment: {
    wallets: {
      bitcoin: 'bc1quxlnwycepgm9d3zspwvmgljs0fwjv057cd2v2n',
      usdt: 'TN9trtRud3EuCioyUGPYoYZm9hU1dPFeew',
    },
  },
};

export default siteConfig;
